<div class="products">
  <h2>商品管理</h2>
  <div class="products-container">
    <div class="toolbar">
      <label class="filter-field">
        商品类型
        <select v-model="selectedProductType" @change="fetchProductList" :disabled="loading">
          <option value="">全部类型</option>
          <option
            v-for="type in PRODUCT_TYPES"
            :key="type.value"
            :value="type.value"
          >
            {{ type.label }}
          </option>
        </select>
      </label>
      <button class="primary-btn" @click="openCreateForm" :disabled="loading || saving">
        新增商品
      </button>
    </div>

    <div class="table-container">
      <div v-if="loading && !detailVisible" class="loading-wrapper">
        <div class="loading-spinner"></div>
        <span>加载中...</span>
      </div>

      <table v-else class="data-table">
        <thead>
          <tr>
            <th class="col-expand"></th>
            <th>ID</th>
            <th>名称</th>
            <th>类型</th>
            <th>描述</th>
            <th>价格</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="productList.length === 0">
            <td colspan="7" class="empty-text">暂无上架商品</td>
          </tr>
          <template v-else v-for="item in productList" :key="pickProductId(item)">
            <tr
              class="product-row"
              :class="{ expanded: isProductExpanded(item) }"
              @click="toggleProductExpand(item)"
            >
              <td class="col-expand">
                <span class="expand-icon">{{ isProductExpanded(item) ? '▼' : '▶' }}</span>
              </td>
              <td>{{ pickProductId(item) }}</td>
              <td class="name-cell">{{ item.name }}</td>
              <td>
                <span class="product-type-tag">{{ formatProductType(item.product_type) }}</span>
              </td>
              <td class="desc-cell">{{ item.description }}</td>
              <td>¥{{ formatPrice(item.price) }}</td>
              <td class="action-column" @click.stop>
                <button class="action-btn edit-btn" @click="openDetail(item)" :disabled="loading || deleting">
                  编辑
                </button>
                <button
                  class="action-btn delete-btn"
                  @click="handleProductDelete(item)"
                  :disabled="loading || deleting"
                >
                  删除
                </button>
              </td>
            </tr>
            <tr v-if="isProductExpanded(item)" class="expand-row">
              <td colspan="7">
                <div class="expand-panel" @click.stop>
                  <div v-if="expandedLoading" class="expand-loading">加载图片中...</div>
                  <div v-else class="expand-panel-body">
                    <div class="section-toolbar">
                      <p class="hint-text">填写顺序 ID 后点击保存；顺序最小且 ID 最小的为主图</p>
                      <button
                        class="primary-btn"
                        @click="triggerImageUpload(item)"
                        :disabled="uploading || sortSavingId != null"
                      >
                        {{ uploading ? '上传中...' : '上传图片' }}
                      </button>
                    </div>

                    <div v-if="imageList.length === 0" class="empty-text expand-empty">暂无图片，请先上传</div>
                    <div v-else class="image-sort-list">
                      <div
                        v-for="img in imageList"
                        :key="pickImageId(img)"
                        class="image-sort-item"
                      >
                        <span v-if="isMainImage(img)" class="main-tag">主图</span>
                        <img
                          v-if="img.url || pickImageUrl(img)"
                          :src="img.url || pickImageUrl(img)"
                          class="image-sort-thumb"
                          alt="商品图"
                          @click="openPreview(img.url || pickImageUrl(img))"
                        />
                        <div v-else class="image-sort-thumb image-thumb-placeholder">无图</div>
                        <div class="image-sort-meta">
                          <span class="image-id-line">商品图片 ID：{{ pickImageId(img) }}</span>
                          <label class="sort-label">
                            顺序 ID
                            <input
                              v-model.number="img.sort_order"
                              type="number"
                              class="sort-input"
                              min="0"
                              step="1"
                              :disabled="sortSavingId === pickImageId(img) || uploading"
                            />
                          </label>
                          <button
                            type="button"
                            class="action-btn save-sort-btn"
                            :disabled="sortSavingId === pickImageId(img) || uploading"
                            @click.stop="handleImageSortSave(img)"
                          >
                            {{ sortSavingId === pickImageId(img) ? '保存中…' : '保存顺序' }}
                          </button>
                        </div>
                        <button
                          type="button"
                          class="action-btn delete-btn image-delete-btn"
                          :disabled="uploading || sortSavingId != null"
                          @click.stop="handleImageDelete(img)"
                        >
                          删除
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <input
        ref="fileInputRef"
        class="hidden-input"
        type="file"
        accept="image/*"
        @change="handleSelectImage"
      />
    </div>
  </div>

  <div v-if="showCreateForm" class="modal-mask" @click="closeCreateForm">
    <div class="modal-panel" @click.stop>
      <h3>新增商品</h3>
      <div class="form-group">
        <label>名称 <span class="required">*</span></label>
        <input v-model="createName" type="text" placeholder="商品名称" />
      </div>
      <div class="form-group">
        <label>描述 <span class="required">*</span></label>
        <textarea v-model="createDescription" rows="4" placeholder="商品描述"></textarea>
      </div>
      <div class="form-group">
        <label>价格 <span class="required">*</span></label>
        <input v-model="createPrice" type="number" min="0" step="0.01" placeholder="0.00" />
      </div>
      <div class="form-group">
        <label>商品类型 <span class="required">*</span></label>
        <select v-model="createProductType">
          <option
            v-for="type in PRODUCT_TYPES"
            :key="type.value"
            :value="type.value"
          >
            {{ type.label }}
          </option>
        </select>
      </div>
      <div class="modal-actions">
        <button class="secondary-btn" @click="closeCreateForm" :disabled="saving">取消</button>
        <button class="primary-btn" @click="handleCreate" :disabled="saving">
          {{ saving ? '创建中...' : '创建' }}
        </button>
      </div>
    </div>
  </div>

  <div v-if="detailVisible" class="modal-mask" @click="closeDetail">
    <div class="modal-panel detail-panel" @click.stop>
      <div class="detail-header">
        <h3>编辑商品 #{{ pickProductId(currentProduct) }}</h3>
        <button class="link-btn" @click="closeDetail">关闭</button>
      </div>

      <div v-if="detailLoading" class="detail-loading">加载中...</div>
      <div v-else-if="currentProduct" class="detail-body">
        <div class="form-group">
          <label>名称</label>
          <input v-model="editName" type="text" />
        </div>
        <div class="form-group">
          <label>描述</label>
          <textarea v-model="editDescription" rows="3"></textarea>
        </div>
        <div class="form-group">
          <label>价格</label>
          <input v-model="editPrice" type="number" min="0" step="0.01" />
        </div>
        <div class="form-group">
          <label>商品类型</label>
          <select v-model="editProductType">
            <option
              v-for="type in PRODUCT_TYPES"
              :key="type.value"
              :value="type.value"
            >
              {{ type.label }}
            </option>
          </select>
        </div>
        <p v-if="currentProduct && currentProduct.created_at" class="meta-line">
          创建时间：{{ currentProduct.created_at }}
        </p>
        <button class="primary-btn" @click="handleUpdate" :disabled="saving">
          {{ saving ? '保存中...' : '保存' }}
        </button>
      </div>
    </div>
  </div>

  <div v-if="previewVisible" class="preview-mask" @click="closePreview">
    <div class="preview-container" @click.stop>
      <img :src="previewUrl" class="preview-image" alt="预览" />
      <button class="preview-close-btn" @click="closePreview">关闭</button>
    </div>
  </div>
</div>
